/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<style type="text/css">\n    .user_image img \n    {\n        width: 100%;\n    }\n    \n    .user_details \n    {\n        padding-left: 0;\n    }\n</style>\n\n\n<div class="col-sm-8 col-sm-offset-2 user_details">\n    <div class="row-fluid">\n        <h3 class="center-block">' +
((__t = ( fullName)) == null ? '' : __t) +
'</h3>\n    </div>\n\n    <table class="table">\n        <tr>\n            <th>Email Address</th>\n            <td><a href="mailto:' +
((__t = ( model.EmailAddress )) == null ? '' : __t) +
'">' +
((__t = (model.EmailAddress )) == null ? '' : __t) +
'</a></td>\n        </tr>\n        <tr>\n            <th>Phone Number</th>\n            <td>' +
((__t = ( model.PhoneNumber ? '(' + model.PhoneNumber.substr(0, 3) + ') ' + model.PhoneNumber.substr(3, 3) + '-' + model.PhoneNumber.substr(6,4) : 'None' )) == null ? '' : __t) +
'</td>\n        </tr>\n        <tr>\n            <th>Extension</th>\n            <td>' +
((__t = ( model.Extension || 'None' )) == null ? '' : __t) +
'</td>\n        </tr>\n        ';
 if(isAdmin){;
__p += '\n            <tr>\n                <th>Creation Email Sent</th>\n                <td>' +
((__t = ( model.creationEmailSent ? moment(model.creationEmailSent).fromNow() : 'Never')) == null ? '' : __t) +
'</td>\n            </tr>\n        ';
 };
__p += '\n    </table>\n</div>';

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/user/Details.ejs
// module id = 866
// module chunks = 1